import React from 'react';

const ErrorUI = ({ isOrderDetails = false }) => {
  const appendix = isOrderDetails ? '' : 's';
  const refresh = () => {
    window.location.reload();
  };
  return (
    <div className="orders-error-ui">
      <h3>{`Unable to load order${appendix}`}</h3>
      <p className="body">Check back soon or refresh the page</p>
      <button className="button button-primary-md" type="button" onClick={refresh}>
        REFRESH PAGE
      </button>
    </div>
  );
};

export default ErrorUI;
